import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/user.service';
import { CheckUserQuery } from '../interfaces/interfaces';
//import { CheckUserQuery } from 'src/app/@api/models';
//import { AuthService } from 'src/app/@api/services';
import { AuthService } from '../services/auth.service';
import { take } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'sdc-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  public isLoginError = false;
  public query: CheckUserQuery;
  
  constructor(
    private loginAuth: UserService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    //alert("login");
  }

  loginForm = new FormGroup(
    {
      userName: new FormControl('', [Validators.required]),
      password: new FormControl('',[Validators.required])
  })

  get UserName(): FormControl {
    return this.loginForm.get('userName') as FormControl;
  }

  get Password(): FormControl {
    return this.loginForm.get('password') as FormControl;
  }

  isUserValid: boolean = false;

  OnSubmit(UserName, Password)
  {
    this.query = {};
    this.query.userName = this.loginForm.value.userName;
    this.query.password = this.loginForm.value.password;
//alert("Inside OnSubmit Sign-In");
    this.authService.login(this.query).pipe(take(1)).subscribe(res => {
      //console.log(res);
      if (res == "Failure")//.userName != null)
      {
        this.isUserValid = false;
        alert('Login Unsuccessful!');
      }
      else
      {
        //alert("In Else");
        this.isUserValid = true;
        this.loginAuth.setToken(res);
        //localStorage.setItem('currentUser')
        //alert(res);
        
        // Check user role and redirect accordingly
        const userInfo = this.loginAuth.jwtHelperService.decodeToken(res);
        if (userInfo && userInfo.role === 'Attendance') {
          this.router.navigateByUrl('attendance');
        } else {
          this.router.navigateByUrl('home');
        }
      }
    });
  }
}
